import encodeJWT from 'garaje/utils/encode-jwt';

export function encodeJWTforJohnDoe() {
  return encodeJWT({
    payload: {
      aud: '1f9eb6be-a985-11e7-8e01-e3c177cb3654',
      exp: 1507631333,
      iat: 1507588133,
      iss: 'Envoy-dev',
      jti: 'bf4a818e-ae28-489d-91da-e646f6c9dbf2',
      meta: { company_id: '1' },
      scopes: ['token.refresh', 'first_party', 'identity.basic', 'public'],
      sub: 'User:1',
      typ: 'access',
    },
  });
}
